"use client";

export default function GlobeStaticFallback() {
  return (
    <div className="w-full h-full flex items-center justify-center relative">
      <div
        style={{
          width: "70%",
          maxWidth: 420,
          aspectRatio: "1 / 1",
          borderRadius: "50%",
          position: "relative",
          background: "radial-gradient(circle at 35% 30%, #1060cc 0%, #0a2a6e 45%, #020d2e 80%)",
          boxShadow: "0 0 60px 10px rgba(0, 200, 255, 0.25), inset -20px -20px 60px rgba(0,0,0,0.5), inset 10px 10px 40px rgba(64, 208, 255, 0.25)",
          animation: "globeSpin 40s linear infinite",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: "-6%",
            borderRadius: "50%",
            border: "1px solid rgba(34, 211, 238, 0.35)",
            animation: "ringPulse 4s ease-in-out infinite",
          }}
        />
        <div
          style={{
            position: "absolute",
            inset: "-14%",
            borderRadius: "50%",
            border: "1px solid rgba(168, 85, 247, 0.25)",
            animation: "ringPulse 4s ease-in-out infinite 1.3s",
          }}
        />
      </div>

      <style jsx>{`
        @keyframes globeSpin {
          from {
            background-position: 0% 0%;
          }
          to {
            background-position: 200% 0%;
          }
        }
        @keyframes ringPulse {
          0%,
          100% {
            transform: scale(1);
            opacity: 0.6;
          }
          50% {
            transform: scale(1.04);
            opacity: 0.15;
          }
        }
      `}</style>
    </div>
  );
}
